// TRIL-402: single source of truth for the direct-messages route, with an optional
// `?c=<convId>` to open a specific conversation and `&u=<otherUsername>` so a
// brand-new thread (not yet in the inbox) shows the counterparty's name in the
// header immediately. Mirrors the postAnalysisPath / reputationPath helper pattern.
// `username` is the CURRENT user's own handle (the route is the caller's inbox).
export function directMessagesPath(
  username: string,
  convId?: string,
  otherUsername?: string,
): string {
  const base = `/user/${username}/direct-messages`;
  if (!convId) return base;
  const params = new URLSearchParams({ c: convId });
  if (otherUsername) params.set('u', otherUsername);
  return `${base}?${params.toString()}`;
}
